// extracted by mini-css-extract-plugin
export default {"option":"pkvsR"};